import React from 'react';
import SelectBoxWithTitle from '../../../elementsHTML/SelectWithTitle';

const NavigationComponent = (props: any) => {
  
  return (
    <>
      <SelectBoxWithTitle
        list={props.treeMenu.main}
        title="main.title"
        baseUrl="/main"
        objectType="main"
      />
    </>
  );
};

export default function Navigation(props: any) {
  return <NavigationComponent {...props} />;
}
